import { FaEnvelope, FaPhone, FaWhatsapp } from 'react-icons/fa';
import './Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section contact-section">
          <h4>Location</h4>
          <p>Fortis Tower, 3rd Floor</p>
          <p>Woodvale Grove, Westlands</p>
          <p>P.O. Box 14154-00800 Nairobi</p>
          <a href="https://maps.app.goo.gl/JY3sLS54ovzpDKDHA">
            <button>Locate us</button>
          </a>
          <div className="contact-info">
            <a href="mailto:info@kagwekamaukaranja.com" aria-label="Email">
              <FaEnvelope /> info@kagwekamaukaranja.com
            </a>
            <a href="tel:0204447575" aria-label="Phone">
              <FaPhone /> 0204447575
            </a>
            <a 
              href="https://wa.me/+254715757575" 
              aria-label="WhatsApp"
              target="_blank" 
              rel="noopener noreferrer"
            >
              <FaWhatsapp /> +254 715 757 575
            </a>
          </div>
        </div>

        <div className="footer-section links-section">
          <h4>Quick Links</h4>
          <div className="links-list">
            <Link to="/support">Support Services</Link>
            <Link to="/industry">Focus Industry</Link>
            <Link to="/future">Future Outlook</Link>
            <Link to="/quality">Quality Assurance</Link>
            <Link to="/confidentiality">Confidentiality</Link>
            <Link to="/indemnity">Professional Indemnity</Link>
            <a href="https://www.indexregistrars.com/" target="_blank" rel="noopener">
              Index Registrars
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2025 Kagwe, Kamau & Karanja Advocates. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;